import React from "react"
import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view"
import {getIntervalLabel} from "../../../../../gd/utils/datetime/get-interval-label"

export default function FieldDate_QuickFilterView(props: FieldQuickFilterViewProps) {


    const label = (props.value && props.value !== 'null') ? getIntervalLabel(props.value) : 'Not set'


    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            <div className="name">{label}</div>
        </div>
    )
}
